import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_ds_inventory_pallet_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licenseplateId?: number, fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], licenseplateStatusId?: number, lotStatusId?: number, vendorlotTextSearch?: string, take?: number, skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string } } }, Packaging?: { ShortName?: string }, LicensePlate?: { LookupCode?: string, ParentId?: number, TypeId?: number, Location?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } }, ParentLicensePlate?: { Id?: number, LookupCode?: string } }, WeightUom?: { Short_name?: string }, inbound_order?: { OrderId?: number, LotId?: number, ActualTargetLicensePlateId?: number, order?: { Id?: number, LookupCode?: string } }, lot_availability?: { TotalAvailablePackagedAmount?: number } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_inventory_pallet_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { licenseplateId?: number, fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], licenseplateStatusId?: number, lotStatusId?: number, vendorlotTextSearch?: string, take?: number, skip?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string } } }, Packaging?: { ShortName?: string }, LicensePlate?: { LookupCode?: string, ParentId?: number, TypeId?: number, Location?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } }, ParentLicensePlate?: { Id?: number, LookupCode?: string } }, WeightUom?: { Short_name?: string }, inbound_order?: { OrderId?: number, LotId?: number, ActualTargetLicensePlateId?: number, order?: { Id?: number, LookupCode?: string } }, lot_availability?: { TotalAvailablePackagedAmount?: number } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_inventory_pallet_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { licenseplateId?: number, fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], licenseplateStatusId?: number, lotStatusId?: number, vendorlotTextSearch?: string, take?: number, skip?: number, $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Lot?: { LookupCode?: string, MaterialId?: number, ReceiveDate?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, Vat?: string }, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string } } }, Packaging?: { ShortName?: string }, LicensePlate?: { LookupCode?: string, ParentId?: number, TypeId?: number, Location?: { Id?: number, Name?: string, Warehouse?: { Id?: number, Name?: string } }, ParentLicensePlate?: { Id?: number, LookupCode?: string } }, WeightUom?: { Short_name?: string }, inbound_order?: { OrderId?: number, LotId?: number, ActualTargetLicensePlateId?: number, order?: { Id?: number, LookupCode?: string } }, lot_availability?: { TotalAvailablePackagedAmount?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_inventory_pallet_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      licenseplateId?: number, fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[], licenseplateStatusId?: number, lotStatusId?: number, vendorlotTextSearch?: string, take?: number, skip?: number    }) {
      return false;
    }
}
